import { takeLatest, all, call, put, select } from "redux-saga/effects";
import { updateHorarioVans, allHorariosVans as allHorariosVansAction, resetHorarioVans } from "./actions";
import types from "./types";
import {api} from "../../../services/api";
import consts from "../../../consts";
const clientID=  sessionStorage.getItem("id");


export function* allHorariosVans() {
  const {  auth , cliente , vansReservadas } = yield select((state) => state.cliente);
  const { form } = yield select((state) => state.horario);
  try {
    yield put(updateHorarioVans({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/extratime`, {
      headers: {
        Authorization: `Bearer ${
          auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
        }`,
      },
    }
    );  
    yield put(updateHorarioVans({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    
    yield put(updateHorarioVans({ vansReservadas : res  }));

  } catch (error) {
    yield put(updateHorarioVans({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* filterHorarioVans() {
  const { form, horario, vans_user} = yield select((state) => state.horario);
  const { auth } = yield select((state) => state.cliente);
  try {
    yield put(updateHorarioVans({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/extratime/users/${sessionStorage.getItem("id")}`, {
      headers: {
        Authorization: `Bearer ${
          auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
        }`,
      },
    });

    yield put(updateHorarioVans({ vans_user : res  }));

    yield put(updateHorarioVans({ form: { ...form, filtering: false } }));
    if (res.error) {
      
      alert(res.message);

      return false;
    }

    
  
  } catch (error) {
   
    yield put(updateHorarioVans({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* addHorarioVans() {
  const {  auth } = yield select((state) => state.cliente);
  const { form, horario, components, behavior } = yield select((state) => state.Vans);
  const clientID=  sessionStorage.getItem("id");

  try {
    yield put(updateHorarioVans({ form: { ...form, saving: true } }));
    let res = {}
  
    if(behavior === "create"){
   
      const response = yield call(api.post, `/extratime/reserve`,{ extra_time_id   : `${horario.id}`, users_id: `${clientID}`},  {
        headers: {
          Authorization: `Bearer ${
            auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
          }`,
        },
      });
      res = response.data
   

    }else{
      console.log(horario)
      const response = yield call(api.put, `/vans/${horario.id}`, horario);
       res= response.data
    }
    yield put(updateHorarioVans({ form: { ...form, saving: false} }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    yield put(allHorariosVansAction())
    yield put(updateHorarioVans({ components: { ...components, drawer: false } }))
    yield put(resetHorarioVans())
  
  } catch (error) {
    yield put(updateHorarioVans({ form: { ...form, saving: false } }));
    alert(error.message);
  }
}


export function* removeHorarioVans() {
  const { form, horario,  vans_user  } = yield select((state) => state.horario);
  const { auth } = yield select((state) => state.cliente);
  const { id_extratime , components} = yield select((state) => state.Vans);
  try {
    yield put(updateHorarioVans({ form: { ...form, saving: true } }));
      console.log(id_extratime)
    const { data: res } = yield call(api.delete, `/extratime/cancel/${id_extratime.id}`, {
      headers: {
        Authorization: `Bearer ${
          auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
        }`,
      },
    });
    
    yield put(updateHorarioVans({ form: { ...form, saving: false  }}));
   
    if (res.error) {
      alert(res.message);

      return false;
    }

    yield put(allHorariosVansAction())
    yield put(updateHorarioVans({ components: { ...components, drawer: false , confirmDelete: false} }))
    yield put(resetHorarioVans())
  } catch (error) {
    yield put(updateHorarioVans({ form: { ...form, saving: false } }));
    alert(error.message);
  }
}

export function* allServiciosVans() {
  const { form } = yield select((state) => state.horario);

  try {
    yield put(updateHorarioVans({ form: { ...form, filtering: true } }));
    const {data:res} = yield call(api.get, `/servicos`)

    
    yield put(updateHorarioVans({ form: { ...form, filtering: false } }));

    if (res.error) {
   
      alert(res.message);

      return false;
    }

    yield put(updateHorarioVans({servicos: res}))



  } 
  catch (error) {
    yield put(updateHorarioVans({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}



export default all([
  takeLatest(types.ALL_HORARIOS_VANS, allHorariosVans),
  takeLatest(types.FILTER_HORARIO_VANS, filterHorarioVans),
  takeLatest(types.ADD_HORARIO_VANS, addHorarioVans),
  takeLatest(types.REMOVE_HORARIO_VANS, removeHorarioVans),
  takeLatest(types.ALL_SERVICES_VANS, allServiciosVans),
]);
